import { queryKeys } from '../queryKeys'
import { auditAiRequest } from '../../util/api/audit-ai-api'
import { createDashboardTableHook } from './dashboardHookUtils'
import type {
  DashboardDocumentTableResponse,
  DashboardSortableTableOptions,
} from '@counsel-project/counsel-audit-ai-api'

type UseDashboardTableDocumentsOptions = {
  page?: number
  limit?: number
  rowsPerPage?: number
  sortBy?: DashboardSortableTableOptions['sortBy']
  sortOrder?: DashboardSortableTableOptions['sortOrder']
}

export const useDashboardTableDocuments = createDashboardTableHook<
  DashboardDocumentTableResponse,
  UseDashboardTableDocumentsOptions
>({
  buildQueryKey: queryKeys.dashboardTableDocuments,
  request: auditAiRequest.dashboard.tableDocuments,
  paginationMode: 'url',
  defaultRowsPerPage: 10,
  getOptionPage: (options) => options.page,
  getOptionLimit: (options) => options.limit,
  getOptionRowsPerPage: (options) => options.rowsPerPage,
  getOptionSortBy: (options) => options.sortBy,
  getOptionSortOrder: (options) => options.sortOrder,
})
